import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 20v-16l6 14l6 -14v16","key":"svg-0"}]]

const IconLetterM = createReactComponent('outline', 'letter-m', 'LetterM', __iconNode);

export default IconLetterM;